import { ReactNode } from 'react';

import { Flex, Text } from '@backstage/ui';

import { Spinner } from '@spotify/confidence-core-react';

import styles from './PreviewShell.module.css';

interface PreviewShellProps {
  loading?: boolean;
  error?: unknown;
  children: ReactNode;
}

export const PreviewShell = ({
  loading,
  error,
  children,
}: PreviewShellProps) => {
  if (loading) {
    return (
      <div className={styles.loading}>
        <Spinner size={24} />
      </div>
    );
  }
  if (error) {
    return (
      <Text variant="body-small" color="secondary">
        Could not load preview.
      </Text>
    );
  }
  return (
    <Flex direction="column" gap="3">
      {children}
    </Flex>
  );
};
